// import axios from 'axios';
import { butter } from '@/buttercms'

export const api = {
  getWorks() {
    return butter.page.list('work', {
      order: '-year',
      levels: 1
    })
  },
  getWorkBySlug(slug) {
    return butter.page.retrieve('work', slug)
  }
}

export const imageApi = {
  getUrl(url, opts = {}) {
    if(!url) {
      return '';
    }
    const defaults = {
      q: 'auto:best',
      f: 'auto',
      w: null,
      h: null,
      c: null,
      b: null,
      g: null
    }
    const options = Object.assign({}, defaults, opts);
    const params = Object.keys(options).filter(x => options[x] !== null).map(x => `${x}_${options[x]}`).join();
    return `https://res.cloudinary.com/akworks/image/fetch/${params}/${url}`;
  }
}